import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const PathologyFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Pathology Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the PathologyFrame component. Replace this with your actual
          UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default PathologyFrame;
